module.exports = __webpack_public_path__ + "2ea2a3be9d185530a12267e94cce34df.svg";